const messages = {
    projects: "Projects",
    experience: "Experience",
    contact: "Contact",
};

export default messages;
